import { render, staticRenderFns } from "./sweet-textarea.vue?vue&type=template&id=b76a754c&"
import script from "./sweet-textarea.vue?vue&type=script&lang=js&"
export * from "./sweet-textarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports